import { Unauthorized } from '@ad-scripts/application/lib/error';
import { logout } from 'src/actions/auth/authSlice';
import createCollectionResource from 'src/actions/shared/createResource';
import * as sharedTypes from 'src/actions/shared/sharedTypes';
import { toastError, toastSuccess } from 'src/actions/toast';
import emptyObserverCreator from '../shared/emptyObserverCreator';

export interface Recording {
  id: string;
  path: string;
  url: string;
}

const recordingsResource = createCollectionResource<Recording>({
  name: 'recordings',
  endpoint: 'v1/orgs/:orgId/configuration/ivr-recordings',
  observerCreator: emptyObserverCreator,
});

const { addStarted, addSuccess, addRequestError } = recordingsResource.actions;

const add: sharedTypes.AppThunk =
  (params: any, attrs: any) =>
  async (dispatch, getState, { gateways }) => {
    try {
      dispatch(addStarted({}));
      const result = await gateways.recordings.add(params, attrs);
      dispatch(addSuccess(result));

      dispatch(toastSuccess('Recording uploaded successfully'));
      return result;
    } catch (err) {
      if (err instanceof Unauthorized) {
        dispatch(logout());
      } else {
        dispatch(addRequestError(err));
      }
      dispatch(toastError('There was an error during recording upload'));
    }
  };

recordingsResource.effects.add = add;

export default recordingsResource;
